function Issues() {
    return (
        <div>
            <h1>CRM oder wie das heißt</h1>
        </div>
    );
}

export default Issues;